import { themeMap, defaultTheme } from '../../types';
import { getFormattedValue, getLegendConfig } from '../util';
import { CnBarStyle } from './type';

export function getBarChartOptions(chartStyle: CnBarStyle) {
  const { xFieldConfig, yFieldConfig, legendConfig, toolTipConfig, themeColor } = chartStyle;
  const { yFieldTitle: originalYFieldTitle, yNameGap } = yFieldConfig || {};
  const { xFieldTitle: originalXFieldTitle, formatXFieldLabel, scale } = xFieldConfig || {};
  const { showLegend } = legendConfig || {};
  const { formatToolTipValue } = toolTipConfig || {};

  const xFieldTitle = getFormattedValue(originalXFieldTitle);
  const yFieldTitle = getFormattedValue(originalYFieldTitle);

  const offsetLeft = yFieldTitle ? 24 : 0;

  return {
    color: themeMap[themeColor || defaultTheme].color,
    legend: getLegendConfig(showLegend, { left: offsetLeft }),
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      valueFormatter: (value: number | string) => {
        return getFormattedValue(formatToolTipValue || value, value);
      },
    },
    xAxis: {
      type: 'value',
      name: xFieldTitle,
      scale: !scale,
      nameGap: 32,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        formatter: (value: string) => {
          return getFormattedValue(formatXFieldLabel || value, value);
        },
      },
    },
    yAxis: {
      type: 'category',
      name: yFieldTitle,
      inverse: true,
      nameGap: yNameGap,
      splitLine: {
        show: false,
      },
      axisTick: {
        alignWithLabel: true,
      },
    },
    grid: {
      top: showLegend ? 32 : 12,
      left: offsetLeft,
      right: 12,
      bottom: xFieldTitle ? 24 : 12,
      containLabel: true,
    },
    style: {
      maxWidth: 50,
    },
  };
}
